import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

var styles = {"container":"panneau-element-avatar-container","letter":"panneau-element-avatar-letter","image":"panneau-element-avatar-image","small":"panneau-element-avatar-small","large":"panneau-element-avatar-large","square":"panneau-element-avatar-square","blend":"panneau-element-avatar-blend","inverted":"panneau-element-avatar-inverted","hidden":"panneau-element-avatar-hidden"};

var propTypes = {
  name: PropTypes.string,
  shortName: PropTypes.string,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  image: PropTypes.shape({
    url: PropTypes.string
  }),
  theme: PropTypes.shape({
    text: PropTypes.string,
    background: PropTypes.string,
    border: PropTypes.string
  }),
  square: PropTypes.bool,
  size: PropTypes.string,
  inverted: PropTypes.bool,
  blended: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};
var defaultProps = {
  name: null,
  shortName: null,
  type: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "CGvQxc",
    defaultMessage: [{
      "type": 0,
      "value": "User"
    }]
  }),
  image: null,
  theme: null,
  size: null,
  square: false,
  inverted: false,
  blended: false,
  className: null,
  children: null
};
var Avatar = function Avatar(_ref) {
  var name = _ref.name,
    shortName = _ref.shortName,
    type = _ref.type,
    image = _ref.image,
    theme = _ref.theme,
    size = _ref.size,
    square = _ref.square,
    inverted = _ref.inverted,
    blended = _ref.blended,
    className = _ref.className,
    children = _ref.children;
  var _ref2 = theme || {},
    textTheme = _ref2.text,
    backgroundTheme = _ref2.background,
    borderTheme = _ref2.border;
  var title = name || shortName || type;
  var _ref3 = image || {},
    _ref3$url = _ref3.url,
    imageUrl = _ref3$url === void 0 ? null : _ref3$url;
  var withImage = imageUrl !== null;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "text-".concat(textTheme), textTheme !== null), "bg-".concat(backgroundTheme), backgroundTheme !== null), "border-".concat(borderTheme), borderTheme !== null), styles[size], size !== null), styles.square, square), styles.inverted, inverted), styles.blend, withImage && blended), styles.hidden, !withImage && shortName === null), className, className !== null)]),
    style: _objectSpread({}, withImage ? {
      backgroundImage: "url(".concat(image.url, ")")
    } : null),
    title: title
  }, !withImage && shortName !== null ? /*#__PURE__*/React.createElement("span", {
    className: styles.letter
  }, shortName) : null, withImage ? /*#__PURE__*/React.createElement("img", {
    className: styles.image,
    src: image.url,
    title: title,
    alt: title
  }) : null, children);
};
Avatar.propTypes = propTypes;
Avatar.defaultProps = defaultProps;

export { Avatar as default };
